'use client';

import { useId } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { Field } from '@/shared/components/form/field';
import { FieldLabel } from '@/shared/components/form/field-label';
import { FieldError } from '@/shared/components/form/field-error';
import { Input } from '@/shared/components/primitives/input';

type InputFieldProps = {
  label?: string;
  isRequired?: boolean;
  fieldClassName?: string;
  className?: string;
  inputProps: UseFormRegisterReturn;
  errorMessage?: string;
  type?: string;
  placeholder?: string;
  autoComplete?: string;
  maxLength?: number;
  disabled?: boolean;
};

export const InputField = ({
  label,
  isRequired,
  fieldClassName,
  className,
  inputProps,
  errorMessage,
  type = 'text',
  placeholder,
  autoComplete,
  maxLength,
  disabled,
}: InputFieldProps) => {
  const inputId = useId();
  const errorId = `${inputId}-error`;

  return (
    <Field className={fieldClassName}>
      {label && (
        <FieldLabel htmlFor={inputId} isRequired={isRequired}>
          {label}
        </FieldLabel>
      )}
      <Input
        {...inputProps}
        id={inputId}
        type={type}
        className={className}
        autoComplete={autoComplete}
        placeholder={placeholder}
        error={!!errorMessage}
        required={isRequired}
        aria-invalid={!!errorMessage}
        maxLength={maxLength}
        aria-describedby={errorMessage ? errorId : undefined}
        disabled={disabled}
      />
      {errorMessage && (
        <FieldError id={errorId} role='alert'>
          {errorMessage}
        </FieldError>
      )}
    </Field>
  );
};
